<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import BankingJournalsWorkspace from '@/views/Banking/Journals/BankingJournalsWorkspace.vue'

setPageTitle(PageMeta.Banking.Journals.Title)
definePage({ meta: PageMeta.Banking.Journals.Meta })
</script>

<template>
  <BankingJournalsWorkspace />
</template>
